// Global unhandled error and promise rejection handler

interface ErrorReport {
  type: "error" | "unhandledrejection" | "component";
  message: string;
  stack?: string;
  timestamp: string;
  url: string;
}

const errorBuffer: ErrorReport[] = [];
const MAX_BUFFER = 50;
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function bufferError(report: ErrorReport): void {
  if (errorBuffer.length >= MAX_BUFFER) errorBuffer.shift();
  errorBuffer.push(report);

  // Debounced flush
  if (!flushTimer) {
    flushTimer = setTimeout(flushErrors, 2000);
  }
}

function flushErrors(): void {
  flushTimer = null;
  if (errorBuffer.length === 0) return;

  const errors = [...errorBuffer];
  errorBuffer.length = 0;

  try {
    navigator.sendBeacon?.(
      "/api/v1/client-errors",
      JSON.stringify({ errors })
    );
  } catch {
    // Silent fail
  }
}

export function initErrorReporting(): void {
  window.addEventListener("error", (event) => {
    bufferError({
      type: "error",
      message: event.message || "Unknown error",
      stack: event.error?.stack,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const message = event.reason instanceof Error
      ? event.reason.message
      : String(event.reason);
    bufferError({
      type: "unhandledrejection",
      message,
      stack: event.reason?.stack,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    });
  });
}

export function getErrorBuffer(): ErrorReport[] {
  return [...errorBuffer];
}
